var unirest = require('unirest');
const API = require ('Api') ;


export async function getCourseSubjectTools ( token , courseSubjectID) {
    const res =  await unirest.get( API.V2 + API.NOTEBOOKS + "subjects/"+courseSubjectID )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseSubjectNotebookItems ( token , courseSubjectID) {
    const res =  await unirest.get( API.V2 + API.NOTEBOOKS + "subjects/"+courseSubjectID+"/items" )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function addCourseSubjectNotebookItem ( token, courseSubjectID, personaID, toolID, 
        evalTypeOptID, evalTypeValue , comments ) {

    let data =  { tool_id: toolID, persona_id: personaID, eval_type_opt_id: evalTypeOptID, 
                    eval_type_value: evalTypeValue , comments: comments } ;

    const res =  await unirest.post(API.V2 + API.NOTEBOOKS + "subjects/"+courseSubjectID+"/items/")
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    .send(data)
    if (res.error) console.log(res.error)
    let list = res.body ;
    return list ;
}
